// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3geNe","info":"Note_info__20t6s","note":"Note_note__1lOIn","actions":"Note_actions__11jW1"};